import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const AssociationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 0;

  h4.title {
    font-size: 20px;
    font-weight: bold;
    color: ${themeGet('text.0', '#323232')};
    margin-bottom: 18px;
  }
  .logos {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    .logo-item {
      display: flex;
      flex-direction: column;
      margin-right: 60px;

      .association-name {
        font-size: 15px;
        font-weight: bold;
        color: #8d8d8d;
      }
    }

    .logo-item-demo {
      display: flex;
      justify-content: space-between;
      margin-right: 30px;
    }
  }
`;

export const AssociationLogosWrapper = styled.div`
  display: flex;
  padding: 15px 0 5px;
  height: 60px;
  img {
    margin-right: 20px;
  }
`;
